import {
    getSettingsLanguage,
    getUserConfiguration,
    getUserConfigurationCollection,
    saveSettingsLanguage,
} from '@retail/user-settings-utils';
import { getFeatureConfig } from '@luna/feature-config';
import type { Language } from '@luna/i18n';
import { getNormalizedLanguage, getQueryLanguage } from '@luna/i18n';
import { logger } from '@luna/logger';
import { getAllowedLanguages, isLanguageAllowed } from '@retail/core';

async function getWebApiLanguage(): Promise<Language | null> {
    const language = await getSettingsLanguage();
    return getNormalizedLanguage(getAllowedLanguages(), language);
}

function getGeorgeBackofficeLanguage(): Language | null {
    return getNormalizedLanguage(getAllowedLanguages(), getUserConfiguration().get('language'));
}

export async function saveLanguage(currentLanguage: Language): Promise<any[]> {
    if (!isLanguageAllowed(currentLanguage)) {
        return [];
    }

    const promises = [
        saveSettingsLanguage(currentLanguage),
        getUserConfigurationCollection().saveLanguage(currentLanguage),
    ];

    try {
        return await Promise.all(promises);
    } catch {
        logger.debug('Error: Can not save current language.');
        return [];
    }
}

export async function getInitialLanguage(): Promise<Language> {
    getUserConfigurationCollection().addFrontendConfig();
    const languagesByPreference = [getQueryLanguage(getAllowedLanguages())];
    if (getFeatureConfig((config) => config.base.preferWebApiLanguage)) {
        const webApiLanguage = await getWebApiLanguage();
        languagesByPreference.push(webApiLanguage);
    }
    languagesByPreference.push(getGeorgeBackofficeLanguage());
    const preferredLanguage = languagesByPreference.find(Boolean);
    return preferredLanguage ?? getFeatureConfig((config) => config.base.defaultLanguage);
}

export function setHtmlLangAttribute(lang: Language): void {
    document.documentElement.lang = lang;
}
